import { Button, Field, TextInput } from "@nabble/ui";
import type { FormEvent } from "react";

interface RecoveryCodeFormProps {
  value: string;
  onChange: (value: string) => void;
  loading: boolean;
  error: string | null;
  onVerify: () => void;
}

/** Sign-in with one of the saved recovery codes. */
export function RecoveryCodeForm({ value, onChange, loading, error, onVerify }: RecoveryCodeFormProps): React.JSX.Element {
  function onSubmit(e: FormEvent): void {
    e.preventDefault();
    if (value.trim()) onVerify();
  }

  return (
    <form className="nb-auth-form" onSubmit={onSubmit}>
      <Field
        label="Recovery code"
        help="Use one of the codes you saved when you set up your account. Each code can be used only once."
        error={error ?? undefined}
      >
        <TextInput
          icon="key"
          mono
          autoComplete="off"
          autoCapitalize="none"
          spellCheck={false}
          autoFocus
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </Field>
      <Button type="submit" label="Verify" size="lg" block loading={loading} disabled={!value.trim()} />
    </form>
  );
}
